import MarketUpdatesCard from '@/features/market-rail/components/MarketUpdatesCard'
import PopularStocksCard from '@/features/market-rail/components/PopularStocksCard'

/**
 * Every Signal Zone page's right rail (owner 2026-10-12, decision 7): Market
 * news and Popular stocks, as the frames draw it. The shared `<MarketRail />`
 * would add Fear and greed here, since these routes sit under `/market`, and
 * that card is not in the signals frames. The frames' ask bar is the docked
 * Ask Mitra bar's page chip now (owner, 2026-10-17).
 *
 * The shared rail's own cards, so `ScreenLayout` fits them exactly as it does
 * on every other screen. Hand it to a screen through `signalsRailProps`.
 */
export default function SignalsRail() {
  return (
    // `gap-10`: the shared rail's 40px rhythm (see `MarketRail`), set here
    // because `ScreenLayout` gives a screen's own rail a flat `gap-4`.
    <div className="flex flex-col gap-10">
      <MarketUpdatesCard />
      <PopularStocksCard />
    </div>
  )
}
